import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'bushDark',
      d: 'M2,-3h0.5v0.5h-0.5zM2,-2.5h1v1h-1zM0,-1.5h3v0.5h-3zM-0.5,-1h3.5v0.5h-3.5zM-3,-0.5h6v0.5h-6zM-2,0h2v0.5h-2zM0.5,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'berryBush',
      d: 'M-2,-3.5h2v0.5h-2zM0.5,-3.5h0.5v0.5h-0.5zM-2.5,-3h0.5v0.5h-0.5zM-1.5,-3h1v0.5h-1zM0.5,-3h1.5v0.5h-1.5zM-1.5,-2.5h2v0.5h-2zM1,-2.5h1v0.5h-1zM-3,-2h1.5v0.5h-1.5zM-1,-2h2v0.5h-2zM1.5,-2h0.5v0.5h-0.5zM-3.5,-1.5h2.5v0.5h-2.5zM-0.5,-1.5h0.5v0.5h-0.5zM-3,-1h2.5v0.5h-2.5z',
    },
    {
      paint: 'leafLight',
      d: 'M0,-3.5h0.5v0.5h-0.5zM-2,-3h0.5v0.5h-0.5zM-0.5,-3h1v0.5h-1zM-2.5,-2.5h1v0.5h-1z',
    },
    {
      paint: 'berry',
      d: 'M0.5,-2.5h0.5v0.5h-0.5zM-1.5,-2h0.5v0.5h-0.5zM1,-2h0.5v0.5h-0.5zM-1,-1.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 83,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
